import Vue from "vue";
import * as Sentry from "@sentry/vue";

// TODO Low: Drop this file, test if Vue is loaded via webpack async loading (without the use of `import`)?
// Init due to DSN present?
let dsn = document?.documentElement?.getAttribute('data-sentry-dsn');

if (dsn) {

    Sentry.init({
        Vue,
        dsn: dsn,
        tracesSampleRate: 1.0,
    });
}
